import React, { Component } from "react";

export const GetPostComments = async ( crsnum, ID) => {
  return fetch(`api/Community/GetPostComments/${crsnum}/${ID}`)
    .then(handleResponse)

    .then(response => response.json());
};
export const GetAllPosts = async crsnum => {
  return fetch(`api/Community/GetPosts/${crsnum}`)
    .then(handleResponse)

    .then(response => response.json());
};
const handleResponse = response => {
  if (!response.ok) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      console.log(this.props);
      window.location = "http://www.google.com";
    }

    return Promise.reject();
  }
  return Promise.resolve(response);
};



// WEBPACK FOOTER //
// ./src/pages/course/Community/API.js